import { Link } from "react-router-dom";
import Avatar from "@/shared/data-display/avatar";

export function Logo({
  src,
  companyName,
}: {
  src?: string;
  companyName?: string | null;
}) {
  return (
    <Link to="/">
      {src ? (
        <img
          src={src}
          alt={companyName ?? ""}
          className="max-w-[200px] aspect-[200/60] size-full object-contain object-left"
        />
      ) : (
        <Avatar
          className="!size-8 xl:!size-10"
          src={src}
          alt={companyName ?? ""}
        />
      )}
    </Link>
  );
}
